export * from './drag-and-drop.module';
export * from './draggable-helper.provider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/node_modules/angular-draggable-droppable/dist/esm/src/index.js
// module id = ../../../../angular-draggable-droppable/dist/esm/src/index.js
// module chunks = common